// export default function ({ $axios, app }) {
//   // Set default credentials for all requests
//   $axios.defaults.withCredentials = true

//   // Request interceptor
//   $axios.onRequest((config) => {
//     // Add any headers or modify request here
//     // All API calls go through the gateway
//     return config
//   })

//   // Response interceptor
//   $axios.onResponse((response) => {
//     return response
//   })

//   // Error interceptor
//   $axios.onError((error) => {
//     const code = parseInt(error.response && error.response.status)
//     if (code === 401) {
//       // Handle unauthorized - redirect to gateway authorization
//       const gatewayUrl = process.env.GATEWAY_URL || 'http://localhost:6061'
//       window.location.href = `${gatewayUrl}/oauth2/authorization`
//     }
//     return Promise.reject(error)
//   })
// }

// new old url
export default function ({ $axios, app, $config }) {
  // Set default credentials for all requests
  $axios.defaults.withCredentials = true

  // Request interceptor
  $axios.onRequest((config) => {
    return config
  })

  // Response interceptor
  $axios.onResponse((response) => {
    return response
  })

  // Error interceptor
  $axios.onError((error) => {
    const code = parseInt(error.response && error.response.status)

    if (code === 401) {
      // ✅ FIX: use $config instead of process.env
      const gatewayUrl = $config.gatewayUrl

      window.location.href = `${gatewayUrl}/oauth2/authorization`
      console.log("Skipping auth redirect (no backend yet)")

    }

    return Promise.reject(error)
  })
}